import { path } from "framer-motion/client";
import { Whitelogo } from "../controller/Images";
import { Colorlogo } from "../controller/Images";

export const Navlink = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "AI",
    path: "/artificial-intelligence",
  },
  {
    name: "Cloud",
    path: "/cloud-managed-services",
  },
  {
    name: "ERP",
    path: "/erp-managed-services",
  },
  {
    name: "Products",
    path: "/Products",
  },
  {
    name: "Insights",
    path: "/Blog",
  },
  {
    name: "Services",
    path: "/Services",
  },
  {
    name: "Join Our Team",
    path: "/join-our-team",
  },
  {
    name: "Let's Talk",
    path: "/lets-talk",
  },
  {
    name: "Success Stories",
    path: "/success-stories",
  },
];

export const Company = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Join Our Team",
    path: "/join-our-team",
  },
  {
    name: "Let's Talk",
    path: "/lets-talk",
  },
  {
    name: "Insights",
    path: "/Blog",
  },
  {
    name: "Success Stories",
    path: "/success-stories",
  },
];

export const Product = [
  {
    name: "AI",
    path: "/artificial-intelligence",
  },
  {
    name: "Cloud",
    path: "/cloud-managed-services",
  },
  {
    name: "ERP",
    path: "/erp-managed-services",
  },
  {
    name: "Products",
    path: "/Products",
  },
  {
    name: "Services",
    path: "/Services",
  },
];

export const navItems = [
  {
    id: "ArtificialIntelligence",
    name: "AI",
    beforeScrollOrder: 2,
    afterScrollOrder: 2,
    path: "/artificial-intelligence",
  },
  {
    id: "tech-stack",
    name: "Cloud",
    beforeScrollOrder: 3,
    afterScrollOrder: 3,
    path: "/cloud-managed-services",
  },
  {
    id: "ERP",
    name: "ERP",
    beforeScrollOrder: 4,
    afterScrollOrder: 4,
    path: "/erp-managed-services",
  },
  {
    id: "Services",
    name: "Services",
    beforeScrollOrder: 5,
    afterScrollOrder: 5,
    path: "/Services",
  },
  {
    id: "logo",
    name: "Logo",
    beforeScrollOrder: 1,
    afterScrollOrder: 1,
    beforeScrollImage: Whitelogo,
    afterScrollImage: Colorlogo,
    path: "/",
  },

  {
    id: "products",
    name: "Products",
    beforeScrollOrder: 7,
    afterScrollOrder: 7,
    path: "/Products",
  },
  {
    id: "tech-blog",
    name: "Insights",
    beforeScrollOrder: 8,
    afterScrollOrder: 8,
    // path: "/Blog",
    children: [
      {
        name: "Blog",
        path: "/Blog", // ✅ absolute path
      },
      {
        name: "ERP Product Video Tours",
        path: "/insights/erp-product-videos-tour",
      },
    ],
  },
  {
    id: "join-our-team",
    name: "Join Our Team",
    beforeScrollOrder: 9,
    afterScrollOrder: 9,
    path: "/join-our-team",
  },
  {
    id: "lets-talk",
    name: "Let's Talk",
    beforeScrollOrder: 10,
    afterScrollOrder: 10,
    path: "/lets-talk",
  },
];
